<template>
  <b-card>
    <b-card-header><h4 class="title">ویرایش قرارداد</h4></b-card-header>
    <b-card-body>
      <b-overlay :show="loading">
        <contract-form
          v-if="contract.id"
          :contract="contract"
          :saving="saving"
          :server-errors="serverErrors"
          submit-label="ذخیره تغییرات"
          @submit="updateContract"
        />
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BCardHeader, BOverlay } from 'bootstrap-vue'
import ContractForm from './ContractForm.vue'

export default {
  name: 'ContractEdit',
  components: { BCard, BCardBody, BCardHeader, BOverlay, ContractForm },
  data() {
    return { contract: {}, loading: false, saving: false, serverErrors: {} }
  },
  mounted() { this.getContract() },
  methods: {
    getContract() {
      this.loading = true
      this.$http.get(`contracts/${this.$route.params.id}`)
        .then(({ data }) => {
          const contract = data.contract || (data.data && (data.data.contract || data.data)) || (data.id ? data : null)
          if (!data.status || !contract) throw new Error(data.message || 'دریافت قرارداد با خطا مواجه شد.')
          this.contract = contract
        })
        .catch(error => this.showError(error, 'خطا در دریافت قرارداد'))
        .finally(() => { this.loading = false })
    },
    updateContract(payload) {
      this.saving = true
      this.serverErrors = {}
      this.$http.put(`contracts/${this.$route.params.id}`, payload)
        .then(({ data }) => {
          if (!data.status) throw new Error(data.message || 'ویرایش قرارداد با خطا مواجه شد.')
          this.$bvToast.toast('تغییرات قرارداد با موفقیت ذخیره شد.', {
            title: 'موفقیت', toaster: 'b-toaster-top-right', variant: 'success',
          })
          this.$router.push({ name: 'Contract_Detail', params: { id: this.$route.params.id } })
        })
        .catch(error => {
          this.serverErrors = (error.response && error.response.data && error.response.data.errors) || {}
          this.showError(error, 'خطا در ویرایش قرارداد')
        })
        .finally(() => { this.saving = false })
    },
    showError(error, title) {
      this.$bvToast.toast((error.response && error.response.data && error.response.data.message) || error.message, {
        title, toaster: 'b-toaster-top-right', variant: 'danger',
      })
    },
  },
}
</script>